module.exports = __webpack_public_path__ + "static/cs-logo-43e1f2e6986c8acba273518651ea649b.jpg";